module.exports = __webpack_public_path__ + "media/images/convenient-for-you-435fc1c11ccfa115449ae7c35f7f7289.svg";